import {
    useState,
    useEffect,
    useContext,
    createContext
} from 'react'
import {
    useMediaQuery,
    useTheme
} from '@mui/material'

const Context = createContext()

export default function Provider({ children }) {
    const theme = useTheme()
    const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.sm}px) or (max-height:${theme.breakpoints.values.sm}px)`)
    const isLandscape = useMediaQuery('(orientation: landscape) and (max-height: 600px)')

    const [open, setOpen] = useState(!isMobile)
    const [title, setTitle] = useState('')

    useEffect(() => {
        document.title = title ? `MZ | ${title}` : 'MZ'
    }, [title])

    return (
        <Context.Provider value={{
            open, setOpen,
            title, setTitle,
            isMobile, isLandscape
        }}>
            {children}
        </Context.Provider>
    )
}

export const useDashboard = () => useContext(Context)